import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { BulkUpdateMemberRequest } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

interface UseBulkUpdateMemberMutationOptions {
  companyId: string;
  onSuccess?: (data: AxiosResponse<any>) => void;
  onError?: (error: any) => void;
}

const useBulkUpdateMemberMutation = ({
  companyId,
  onSuccess,
  onError,
}: UseBulkUpdateMemberMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: BulkUpdateMemberRequest) => {
      const res = await axiosInstance.post(api.bulkUpdateMember(companyId), params);
      return res;
    },
    onSuccess: (data) => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useBulkUpdateMemberMutation;
